function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Dashboard"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home-V2-Popout",
  transform: "translate(-747.000000, -479.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-44",
  transform: "translate(727.500000, 432.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-39"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-7",
  transform: "translate(20.133500, 47.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(7.272727, 0.328485)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Adobe_OpacityMaskFilter",
  filterUnits: "userSpaceOnUse",
  x: 0.4,
  y: 0.3,
  width: 11.4,
  height: 11.5
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 0.4,
  y: 0.3,
  width: 11.4,
  height: 11.5,
  id: "mask-2_1_"
}, /*#__PURE__*/React.createElement("g", {
  className: "st0"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1_1_",
  className: "st1",
  points: "0.4,0.3 11.9,0.3 11.9,11.7 0.4,11.7  "
}))), /*#__PURE__*/React.createElement("path", {
  id: "Fill-1",
  className: "st2",
  d: "M11.5,2.3c-3,3-6,6-8.9,8.9c0,0-0.1,0.1-0.1,0.1c-0.7,0.1-1.3,0.3-2,0.4c0,0,0,0-0.1,0 c0,0,0-0.1,0-0.1c0.1-0.6,0.2-1.2,0.4-1.9c0-0.1,0-0.1,0.1-0.1c3-3,6-6,8.9-9c0.6-0.6,1.7-0.4,2,0.4C12,1.7,11.5,2.3,11.5,2.3 z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(0.000000, 0.934545)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill-4",
  className: "st3",
  d: "M9.3,18.8c-2.1,0-4.1,0-6.2,0c-0.7,0-1.3-0.2-1.9-0.6c-0.7-0.6-1.1-1.3-1.2-2.2 c0-0.1,0-0.1,0-0.2c0-4.1,0-8.3,0-12.4c0-1,0.4-1.9,1.3-2.5c0.5-0.3,1-0.5,1.6-0.6c0.1,0,0.1,0,0.2,0c3,0,5.9,0,8.9,0 c0.4,0,0.7,0.1,0.9,0.4c0.4,0.4,0.3,1.1-0.1,1.5c-0.2,0.2-0.5,0.3-0.8,0.3c-2.9,0-5.9,0-8.8,0c-0.3,0-0.5,0.1-0.7,0.3 C2.3,2.8,2.2,3,2.2,3.1c0,0.1,0,0.1,0,0.2c0,4.1,0,8.3,0,12.4c0,0.2,0,0.5,0.2,0.6c0.1,0.2,0.3,0.2,0.5,0.3c0.1,0,0.1,0,0.2,0 c4.1,0,8.3,0,12.4,0c0.4,0,0.7-0.1,0.8-0.5c0.1-0.1,0.1-0.3,0.1-0.5c0-2.3,0-4.7,0-7c0-0.6,0-1.2,0-1.9c0-0.4,0.1-0.7,0.4-0.9 c0.4-0.3,1.1-0.3,1.5,0.1c0.2,0.2,0.3,0.5,0.3,0.8c0,3,0,6,0,9c0,1.3-0.8,2.5-2.1,2.9c-0.3,0.1-0.6,0.1-1,0.1 C13.4,18.8,11.4,18.8,9.3,18.8"
})))))));

var SvgCreateTemplate = function SvgCreateTemplate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreateTemplate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/create-template.b3c6520e.svg";
export { ForwardRef as ReactComponent };